export default __webpack_public_path__ + "static/mask-layer-quote-mb-edb4d3d49fa6cac162257bc067f00b34.png";